export default __webpack_public_path__ + "static/media/img_scsc_7.841e01ba.png";